export default "__VITE_ASSET__Cez4jnWf__"